export const textLabels = {
  body: {
    noMatch: "Kayda Rastlanılmadı",
    toolTip: "Sırala",
    columnHeaderTooltip: (column) => `${column.label} Sırala`,
  },
  pagination: {
    next: "Gelecek Sayfa",
    previous: "Önceki Sayfa",
    rowsPerPage: "Gösterilecek Kayıt Sayısı:",
    displayRows: "Toplam",
  },
  toolbar: {
    search: "Arama",
    downloadCsv: "CSV İndir",
    print: "Yazdır",
    viewColumns: "Kolonları Görüntüle",
    filterTable: "Tablo Filtresi",
  },
  filter: {
    all: "Hepsi",
    title: "Filtre",
    reset: "Sıfırla",
  },
  viewColumns: {
    title: "Kolonları Göster",
    titleAria: "Tablo Kolonlarını Gizle/Aç",
  },
  selectedRows: {
    text: "Kayıt Seçildi",
    delete: "Sil",
    deleteAria: "Seçili Kaydı Sil",
  },
};
